import React, {useContext, useMemo, useState} from 'react'
import {notifyOnError} from "../../../AppLocals/factory/createErrorEvent";
import {NotificationActionTypes, successNotify} from "../../../AppLocals/factory/createNotification";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import {vote_add_Api, vote_remove_Api} from "../../../../apis";
import useTranslate from "../../../../modules/local/useTranslate";
import {LoginContext} from "../../../../components/LoginContext";
import {NullAsDefault} from 'views/Shared'
import {getId} from "../../../../apis/model/base";
import {Modal} from "antd";
import {
    godwords_createNew_Api,
    godwords_delete_Api,
    godwords_setPhoto_Api,
    godwords_update_Api
} from "../../../../apis/godwords";
import {DelayRender} from "../../../Shared/components/DelayRender";
import CRUD from "../../../Shared/enums/CRUD";
import WoGContext, {WoGProvider} from "../../../AppLocals/WoG/WoGContext";
import {captureImage} from "./captureImage";
import {CreateGodWordForm, EditGodWordForm} from "../components/GodWordForm";
import {showDeleteConfirmDialog} from "../../factory/createConfirmDialog";
import {bindQueryParam} from "../../functions/routerHelper";
import LoadingBlock from "../../../Loading/LoadingBlock";


export const useGodWords = ({
                              notifyListeners = {
                                onVotedSuccess: undefined,
                                onDevotedSuccess: undefined,
                                onCreated: undefined,
                                onUpdated: undefined,
                                onDeleted: undefined,
                                onCaptured: undefined
                              },
                            }) => {
  const t = useTranslate()
  const login = useContext(LoginContext)
  const [action, setAction] = useState({type: undefined, value: undefined})

  const {isLoading, handleAsyncAction: handleCapturePhoto} = useAsyncAction({
    apiInfo: godwords_setPhoto_Api,
    onError: notifyOnError(t),
    onSuccess: (result, data) => {
      // successNotify(NotificationActionTypes.UPDATE, t)
      onCaptured(result, data)
      onCancel()
    },
  })

  const handleAction = (action, params) => {

    switch (action) {
      case CRUD.CREATE:
      case CRUD.UPDATE:
      case CRUD.DELETE:
        setAction({type: action, value: params})
        break
      case "photo-capture":
        captureImage(
          params?.divElement,
          (blob) => {
            handleCapturePhoto({photo: blob}, bindQueryParam({
              id: params?.item?.id,
            }))
          }
        )
        break
      default:
        break
    }
  }
  const onCancel = () => {
    setAction({})
  }

  const onSuccess = () => {
    onCancel()
  }
  const {
    onVotedSuccess = NullAsDefault,
    onDevotedSuccess = NullAsDefault,
    onUpdated = onSuccess,
    onCreated = onSuccess,
    onDeleted = onSuccess,
    onCaptured = onSuccess,
  } = notifyListeners ?? {}
  const onError = notifyOnError(t)
  const {handleAsyncAction: onUpdate, ...asyncUpdating} = useAsyncAction({
    onError,
    apiInfo: godwords_update_Api,
    onSuccess: (result, data) => {
      successNotify(NotificationActionTypes.UPDATE, t)
      onUpdated(result, data)
      onCancel()
    }
  })
  const {handleAsyncAction: onCreate, ...asyncCreating} = useAsyncAction({
    onError,
    apiInfo: godwords_createNew_Api,
    onSuccess: (result, data) => {
      successNotify(NotificationActionTypes.CREATE, t)
      onCreated(result, data)
      onCancel()
    }
  })
  const {handleAsyncAction: onDelete, ...asyncDeleting} = useAsyncAction({
    onError,
    apiInfo: godwords_delete_Api,
    onSuccess: (result, data) => {
      successNotify(NotificationActionTypes.DELETE, t)
      onDeleted(result)
    }
  })


  const {handleAsyncAction: onDevote, ...asyncDevoting} = useAsyncAction({
    onError: notifyOnError(t),
    apiInfo: vote_remove_Api,
    onSuccess: (result, data) => {
      successNotify(NotificationActionTypes.UPDATE, t, {description: 'you unliked this'})
      onDevotedSuccess(result, data)
    },
  })
  const {handleAsyncAction: onVote, ...asyncVoting} = useAsyncAction({
    onError: notifyOnError(t),
    apiInfo: vote_add_Api,
    onSuccess: (result, data) => {
      successNotify(NotificationActionTypes.UPDATE, t, {description: 'you liked this'})
      onVotedSuccess(result, data)
    },
  })

  const handleCaptureImage = (divElement, item) => captureImage(
    divElement,
    (blob) => {
      handleCapturePhoto({photo: blob}, bindQueryParam({
        id: item?.id,
      }))
    }
  )

  const modal = useMemo(() => {
    let Content = NullAsDefault
    let Wrapper = ({children}) => children({initialValues: {}})
    let params = {}
    let modal_params = {}
    switch (action.type) {
      case CRUD.CREATE:
        params = {
          onSubmit: (values) => {
            onCreate(values, {})
          },
        }
        modal_params = {
          width: 640,
          title: (
            <div className="text-center font-bold text-color-000 uppercase tracking-wide">
              {t('add words of god')}
            </div>
          ),
        }
        Content = CreateGodWordForm
        break
      case CRUD.DELETE:
        const id = getId(action.value)
        if (id) {
          showDeleteConfirmDialog({
            translate: t,
            onOk: () => {
              onDelete(
                {},
                {
                  id,
                }
              )
            },
          })
        }
        break
      case CRUD.UPDATE:
        params = {
          onSubmit: (values) => {
            onUpdate(values, {id: action.value?.id})
          },
        }
        modal_params = {
          width: 640,
          title: (
            <div className="text-center font-bold text-color-000 uppercase tracking-wide">
              {t('edit words of god')}
            </div>
          ),
        }
        Content = ({...rest}) => (
          <WoGProvider id={getId(action.value)}>
            <WoGContext.Consumer>
              {({item}) => {
                return (
                  <EditGodWordForm
                    {...rest}
                    item={item}
                  />
                )
              }}
            </WoGContext.Consumer>
          </WoGProvider>
        )
        break
      default:
        break
    }

    return (
      <Modal
        className="custom-modal"
        footer={null}
        onCancel={onCancel}
        open={action.type && action.type !== CRUD.DELETE}
        destroyOnHidden={true}
        {...modal_params}>
        <DelayRender lazy={true}>
          <Wrapper>
            {({isLoading, initialValues}) => {
              if (!!isLoading) {
                return <LoadingBlock/>
              }
              return (
                <Content
                  {...{
                    onCancel,
                    item: action.value,
                  }}
                  {...params}
                  initialValues={initialValues}
                />
              )
            }}
          </Wrapper>
        </DelayRender>
      </Modal>
    )
  }, [action])

  return {
    modal,
    handleAction,
    handleCaptureImage,
    onVote,
    onDevote,
    asyncVoting,
    asyncDevoting,
  }
}


